<template>
    <ul class="feature-li">
        <li v-for="page in orderedPages.slice(0, featuremeta[1])" >
        <a :href="page.pageslug">
            <span v-if="featuremeta[2]=='images'" class="li-image" :style="'background-image: url('+page.blockimage+')'"></span>
            <span class="li-content">
                <strong class="li-title">
                    {{ page.pagetitle }} 
                </strong>
                <span class="li-description" v-if="featuremeta[3] == 'desc'">
                    {{ page.pagetext }} 
                </span>
                <span class="li-tags" v-if="page.settings[0] && featuremeta[4] == 'meta '">
                    <span class="li-tag-item" v-for="setting, index in page.settings[0]">
                        <span class="li-tag-key">{{index}}: </span> <span class="li-tag-value">{{setting}}</span>
                    </span>
                </span>
            </span>
        </a>
        </li>
    </ul>
</template>

<script>

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
    props: {
        pageid: String,
        websiteid: String,
        readonly: Boolean,
        featuremeta: Array
    },
    computed: {
      orderedPages: function () {
        return _.orderBy(this.pages, 'order', 'desc')
      }
    },
    data: function() {
        return{
            readonly: false,
            showModal: false,
            pages: {}
        }
    },
    methods: {
        getPages(){
            axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/blockstyle/'+this.featuremeta[0]+'-item')
            .then(response => {
              console.log('pages loaded')
                this.pages = response.data.response
            })
        }
    },
    mounted(){
        this.getPages()
    }
}
</script>